<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (isSearching) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}


<p-table class="yield-max-table" #pt [value]="properties" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="propertyId" selectionMode="single"
  [(selection)]="property" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="250" [rowsPerPageOptions]="[250,500,1000, 2000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [scrollable]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Properties</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text" style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;" (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <!-- <button *ngIf="!outlineNewButton" pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
      (click)="onOpenFormAdd()">New Property +</button> -->
      <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;" (click)="eventConfirmation()">Sync All Properties</button>
    </span>
  </div>
</ng-template>
<ng-template  pTemplate="header">
  <tr>
    @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    }
    <th [ngStyle]="{'width': '80px'}"></th>
  </tr>
  @if (showFilter) {
    <tr>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="statuses" appendTo="body" (onChange)="pt.filter($event.value, 'listingStatus', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown [style]="{'width':'50px','min-width':'100%'}" [options]="locations" appendTo="body"
          (onChange)="pt.filter($event.value, 'locationId', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="locationId"
          [value]="pt.filters['locationId'] ? pt.filters['locationId'].value : ''">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyCode', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'adrUnit', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'developmentName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'numBedrooms', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'numBathrooms', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'RateBucketVO.name', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'annualRevTargetAmnt', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'minNightlyRate', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'minLengthOfStay', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'MgmtCommissionPct', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-property>
  <tr [pSelectableRow]="property">
    <td>{{property.propertyId}} </td>
    <td>{{getStatusName(property)}}</td>
    <td>{{Locations[property['locationId']] }}</td>
    <td style="color:blue">{{property.propertyCode}}</td>
    <td>{{property.adrUnit}}</td>
    <td>{{property.propertyName}}</td>
    <td>{{property.developmentName}}</td>
    <td>{{property.numBedrooms}}</td>
    <td>{{property.numBathrooms}}</td>
    <td>{{property.rateBucketName}}</td>
    <td>{{property.annualRevTargetAmnt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
    <td>{{property.minNightlyRate | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
    <td>{{property.minLengthOfStay}}</td>
    <td>{{property.mgmtCommissionPct | number : '1.2-2' }}</td>
    <td>{{property?.adrStreet}} {{property?.adrBuilding}}
      {{property?.adrCity}}, {{property?.adrState}} {{property?.adrIsland}} {{property?.adrDistrict}}
    {{property?.adrRegion}}</td>
    <td>{{property.vrboId}}</td>
    <td>{{property.extSystemId}}</td>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(property)"></i>
      </a>
    </span>
  </td>
</tr>
</ng-template>
</p-table>